<template>
  <div class="queue queue_red">
    <div class="queue__wrapper">
      <div class="queue__item">
        <div class="queue__text queue__text_big">МТС</div>
      </div>
      <div class="queue__item" v-if="client">
        <div class="queue__text">
          {{ $t('client.number') }}
        </div>
        <div class="queue__text queue__text_big">
          {{ client.number }}
        </div>
      </div>
      <div class="queue__item" v-if="servicing">
        <div class="queue__text">
          {{ $t('servicing.desc') }}
        </div>
        <div class="queue__text queue__text_big">
          {{ servicing.label }}
        </div>
        <div class="queue__text queue__text_small">
          {{ servicing.name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {mapState} from 'vuex'

export default {
  name: 'ServicingInfo',
  computed: {
    ...mapState({
      client: state => state.app.client,
      servicing: state => state.app.servicing
    })
  }
}
</script>
